<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret" /></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'" />
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="row">
            <div class="col-xs-12 col-sm-6 main-location-details left top-small">
              <div class="form-group">
                <label for="code" class="form-label">Code *</label>
                <input type="text" class="form-control" id="code" v-model="entity.code"/>
              </div>
              <div class="form-group">
                <label for="name" class="form-label">Name *</label>
                <input type="text" class="form-control" id="name" v-model="entity.name"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
              <label class="form-label">Brands *</label>
              <div class="panel panel-default">
                <div class="panel-body">
                  <ul class="list-unstyled">
                    <li v-for="(brand, i) in brands">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" v-model="selectedBrands[brand.code]" />{{ brand.name }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import AutoComplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'BrandGroup',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      AutoComplete
    },
    watch: {
      '$route' (val, old) {
        if (!val.params || !val.params.id) {
          this.selectedBrands = {}
        }
      }
    },
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'brandGroups',
        transformForUpdate: {
          brand: this.toMinus
        },
        newEntityScreen: 'Admin - Tariff Set',
        editEntityScreen: 'Admin - Edit/View Tariff Set',
        boxes: [],
        tab: 'main',
        entityName: 'brand-group',
        entity: {
          id: null,
          code: null,
          name: null,
          brands: null
        },
        selectedBrands: {}
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.getSelectedBrands() && this.getSelectedBrands().length > 0
      },
      brands () {
        return this.getSystemOptions('BRAND')
      }
    },
    methods: {
      preSaveRoutine () {
        return new Promise((resolve, reject) => {
          this.entity.brands = this.getSelectedBrands()
          resolve()
        })
      },
      getSelectedBrands () {
        const brands = []
        Object.entries(this.selectedBrands).forEach(([prop, value]) => {
          if (value) { brands.push(prop) }
        })
        return brands.join()
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          brands: null
        }
      },
      initData () {
        for (let prop in this.baseEntity) {
          this.entity[prop] = this.baseEntity[prop]
        }
        if (this.entity.brands) {
          this.entity.brands.split(',').forEach(brand => {
            this.selectedBrands[brand] = true
          })
        }
        this.unbox()
      },
      updateEntity (prop, method, val) {
        this.entity[prop] = this[method](val)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/BrandGroup/BrandGroup.vue